import { EventAssociatedModel, EventLibraryBox } from '~/types/adamTypes';
export const useAppEventLibraryBox = async (
  library: LibrarySchema = null
): Promise<void> => {
  const { createEvent } = useAppEvent(
    EventAssociatedModel.LibraryBox,
    library.id
  );

  if (library && library.appEventSectionId) {
    await createEvent(EventLibraryBox.Clicked, {
      SectionLibrary: library.appEventSectionId,
    });
  }
};
